import React from 'react';
import Modal from 'react-modal';
import { Container, Button, Row, Col } from 'react-bootstrap';
import { FM_DOMAIN_NAME, FM_FILENAME_QUALITY, FM_CHECKLIST_SHORTCUT, FM_ACCOUNT_NAME, FM_ACCOUNT_PASSWORD } from "../../config.js"; //CHANGED UPDATE 2023/06/28 #18
import User from '../../User.js';

Modal.setAppElement("#root");

const customStyles = {
  overlay: {
    zIndex: "100",
    backgroundColor: "rgba(0, 0, 0, 0.5)"
  },
  content: {
    width: "64%",
    maxWidth: "640px",
    maxHeight: "92vh",
    height: "auto",
    top: "calc(50% + 37.5px)",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    padding: "0",
    transform: "translate(-50%, -50%)",
    overflow: "hidden"
  }
};

const ClickEventModal = (props) => {
  const {
    modalIsOpen,
    schedulerData,
    modalParam,
    linestatus,
    refStatus,
    refSetpicture,
    refKatagae,
    // refSyutuzu,
    refSyukkaDate,
    refTbikou,
    refText,
    handleClickEventCloseModal,
    handleSelectedDateUpdateButtonClicked,
    handleBikouUpdateButtonClicked,
    handleSyukkaUpdateButtonClicked,
  } = props;

  const {
    UUID,
    製品番号,
    立米,
    配合,
    ステータス,
    出荷予定日,
    写真撮影,
    型替,
    // 製造用図面の出図,
    図面番号,
    予備日,
    製品備考,
    図面ID1,
    図面ID2,
    図面ID3,
    図面ID4,
    図面ID5,
    図面ID6,
    図面ID7,
    図面ID8,
    備考,
    備考フラグ,
    出荷日テキスト,
    出荷日テキストフラグ,
    日付,
    resourceId,
  } = modalParam;

  var options = linestatus.map(
    (item) => (
      <option key={item.status} value={item.status}>
        {item.status}
      </option>
    )
  );
  const btnAuth = !!User.getAuth();

  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={handleClickEventCloseModal}
      // afterOpenModal={afterOpenModal}
      contentLabel="Modal"
      // closeTimeoutMS={100}
      style={customStyles}
    >
      {modalParam && 製品番号 && (
        <Container className="container__product" style={{ maxHeight: "90vh", overflowY: "auto", overflowX: "hidden", padding: "12px 13px 94px 13px", boxSizing: "border-box" }}>
          {/* CHANGED UPDATE 2023/07/12 #28 */}
          <Row>
            {/* CHANGED:ADD 2023/07/04 #25 */}
            <div className="fm-link__checklist">
              <a
                href={`fmp://${FM_ACCOUNT_NAME}:${FM_ACCOUNT_PASSWORD}@${FM_DOMAIN_NAME}/${FM_FILENAME_QUALITY}?script=${FM_CHECKLIST_SHORTCUT.scriptName}&param=${UUID}`}
              >
                <i />
                <span>チェックリストを開く</span>
              </a>
            </div>
          </Row>
          <Row>
            <Col xs={4}>製品番号</Col>
            <Col xs={8}>{製品番号}</Col>
          </Row>
          <Row>
            <Col xs={4}>㎥</Col>
            <Col xs={8}>{立米}</Col>
          </Row>
          <Row>
            <Col xs={4}>配合</Col>
            <Col xs={8}>{配合}</Col>
          </Row>
          <Row>
            <Col xs={4}>ステータス</Col>
            <Col xs={8}>
              <select defaultValue={ステータス} ref={refStatus}>
                {options}
              </select>
            </Col>
          </Row>
          <Row>
            <Col xs={4}>写真撮影</Col>
            <Col xs={8}>
              <select defaultValue={写真撮影} ref={refSetpicture}>
                <option value={""}>{""}</option>
                <option value={"無"}>{"無"}</option>
                <option value={"有"}>{"有"}</option>
              </select>
            </Col>
          </Row>
          <Row>
            <Col xs={4}>型替</Col>
            <Col xs={8}>
              <select defaultValue={型替} ref={refKatagae}>
                <option value={""}>{""}</option>
                <option value={"無"}>{"無"}</option>
                <option value={"有"}>{"有"}</option>
              </select>
            </Col>
          </Row>
          {/* <Row>
            <Col xs={4}>製造用図面の出図</Col>
            <Col xs={8}>
              <select defaultValue={製造用図面の出図} ref={refSyutuzu}>
                <option value={""}>{""}</option>
                <option value={"済"}>{"済"}</option>
              </select>
            </Col>
          </Row> */}
          <Row>
            <Col xs={4}>図面番号</Col>
            <Col xs={8}>{図面番号}</Col>
          </Row>
          <Row>
            <Col xs={4}>出荷予定日</Col>
            <Col xs={8}>
              <input
                type="date"
                defaultValue={出荷予定日}
                ref={refSyukkaDate}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={4}>予備日</Col>
            <Col xs={8}>{予備日}</Col>
          </Row>
          <Row>
            <Col xs={4}>備考</Col>
            <Col xs={8}>
              <input type="text" defaultValue={製品備考} ref={refTbikou} />
            </Col>
          </Row>
          <Row>
            <Col xs={6}>
              <Row>
                <Col xs={4}>図面番号1</Col>
                <Col xs={8}>{図面ID1}</Col>
              </Row>
            </Col>
            <Col xs={6}>
              <Row>
                <Col xs={4}>図面番号2</Col>
                <Col xs={8}>{図面ID2}</Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col xs={6}>
              <Row>
                <Col xs={4}>図面番号3</Col>
                <Col xs={8}>{図面ID3}</Col>
              </Row>
            </Col>
            <Col xs={6}>
              <Row>
                <Col xs={4}>図面番号4</Col>
                <Col xs={8}>{図面ID4}</Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col xs={6}>
              <Row>
                <Col xs={4}>図面番号5</Col>
                <Col xs={8}>{図面ID5}</Col>
              </Row>
            </Col>
            <Col xs={6}>
              <Row>
                <Col xs={4}>図面番号6</Col>
                <Col xs={8}>{図面ID6}</Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col xs={6}>
              <Row>
                <Col xs={4}>図面番号7</Col>
                <Col xs={8}>{図面ID7}</Col>
              </Row>
            </Col>
            <Col xs={6}>
              <Row>
                <Col xs={4}>図面番号8</Col>
                <Col xs={8}>{図面ID8}</Col>
              </Row>
            </Col>
          </Row>
          <Row className="btn_area">
            <div className="mdl_btn mdl_click">
              <div className="mdl_btn_update">
                <Button
                  disabled={!btnAuth}
                  onClick={() => {
                    handleSelectedDateUpdateButtonClicked(schedulerData, UUID);
                  }}
                >
                  更新
                </Button>
              </div>
              <div className="mdl_btn_cancel">
                <Button onClick={handleClickEventCloseModal}>キャンセル</Button>
              </div>
            </div>
          </Row>
        </Container>
      )}
      {modalParam && !製品番号 && 備考フラグ && (
        <Container className="text_only">
          <Row>
            <Col xs={4}>備考</Col>
            <Col xs={8}>
              <input type="text" defaultValue={備考} ref={refText} />
            </Col>
          </Row>
          <Row className="btn_area">
            <div className="mdl_btn mdl_click">
              <div className="mdl_btn_update">
                <Button
                  disabled={!btnAuth}
                  onClick={() => {
                    handleBikouUpdateButtonClicked(
                      schedulerData,
                      UUID,
                      resourceId,
                      日付
                    );
                  }}
                >
                  更新
                </Button>
              </div>
              <div className="mdl_btn_cancel">
                <Button onClick={handleClickEventCloseModal}>キャンセル</Button>
              </div>
            </div>
          </Row>
        </Container>
      )}
      {modalParam && !製品番号 && 出荷日テキストフラグ && (
        <Container className="text_only">
          <Row>
            <Col xs={4}>出荷</Col>
            <Col xs={8}>
              <input type="text" defaultValue={出荷日テキスト} ref={refText} />
            </Col>
          </Row>
          <Row className="btn_area">
            <div className="mdl_btn mdl_click">
              <div className="mdl_btn_update">
                <Button
                  disabled={!btnAuth}
                  onClick={() => {
                    handleSyukkaUpdateButtonClicked(
                      schedulerData,
                      UUID,
                      resourceId,
                      日付
                    );
                  }}
                >
                  更新
                </Button>
              </div>
              <div className="mdl_btn_cancel">
                <Button onClick={handleClickEventCloseModal}>キャンセル</Button>
              </div>
            </div>
          </Row>
        </Container>
      )}
    </Modal>
  );
}

export default ClickEventModal; 